<div class="layout">
  <app-sidebar class="sidebar" [class.expanded]="isSidebarExpanded" [sidebarExpanded]="isSidebarExpanded"></app-sidebar>
  <div class="content">
    <router-outlet></router-outlet>
  </div>
</div>

<lib-chat *ngIf="authService.isAuthorized(PermissionsEnum.AiChat_Use) && authService.hasConfiguration(DashboardConfiguration.AiWidget)"></lib-chat>
  